import React from 'react';

import { Tooltip, Text, Box } from 'components';
import { numberFormatter, currencyFormatter } from 'helpers';

export default ({ user }) => {
  if (!user) return null;

  const {
    bonus_tokens,
    contribution_usd_equivalent,
    principal_tokens,
  } = user.contribution_summary;

  return (
    <Box flex="1" mr="4" p="4">
      <Box>
        <Box mb="3">
          <Text display="h4">{numberFormatter(principal_tokens)}</Text>
          <Text flex alignItems="center" display="h5">
            Principal CRNC Tokens{' '}
            <Tooltip text="The tokens that will be issued on the day of token issuance." />
          </Text>
        </Box>
        <Box mb="3">
          <Text display="h4">{numberFormatter(bonus_tokens)}</Text>
          <Text flex alignItems="center" display="h5">
            Total Bonus CRNC{' '}
            <Tooltip text="The total number of bonus tokens to be distributed, as per your agreement." />
          </Text> 
        </Box>
        <Box mb="4">
          <Text display="h4">
            {currencyFormatter(contribution_usd_equivalent)}
          </Text>
          <Text flex alignItems="center" display="h5">
            Pegged USD Contribution{' '}
            <Tooltip text="The amount, in USD, of your contribution to the tokensale." />
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
